<footer class="footer" :class="{'footer--mobile': userStore.mobile }">
    <div v-if="showSeo" class="footer__seo">
        <div class="container">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="footer__seo-main" v-if="seoContent" v-html="seoContent?.mainText?.description" :style="{ 'height': seoContent?.mainText?.description === ' ' ? getPlaceholderFooter(config.Themename).mainHeight + 'px' : 'inherit' }" :class="{'empty': seoContent?.mainText?.description === ' '}"></div>
            <div class="footer__seo-tabs">
                <div v-if="seoContent" class="footer__seo-tabs-buttons">
                    <span v-for="seoTab in filteredTabs" :key="seoTab.id" class="btn btn-xsmall btn-black" :class="{ 'active': selectedTab === seoTab.id }" @click="selectedTab = seoTab.id">{{ seoTab.title }}</span>
                </div>
                <div class="footer__seo-tabs-text" v-for="seoTab in seoContent?.texts" v-show="selectedTab == seoTab.id" :key="`tab-content-${seoTab.id}`" :class="{'empty': seoTab?.description === ' '}" :style="{ 'height': seoContent?.mainText?.description === ' ' ? getPlaceholderFooter(config.Themename).secondHeight + 'px' : 'inherit' }">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <span v-html="seoTab?.description"></span>
                </div>
            </div>
        </div>
    </div>
    <div class="footer__copyright">
        <div class="container">
            <div class="footer__copyright-text">
                <img alt="logo" class="footer__copyright-logo" :src="getStaticImages('footerlogo')" />
                <p>{{ $t('footer.slogan-' + config.Themename, {year: (new Date()).getFullYear()}) }}</p>
            </div>
        </div>
    </div>
    <div v-if="showProfileLinks" class="footer__links">
        <div class="container">
            <router-link :to="{name:'contact'}">{{ $t('textpages.contacttitle') }}</router-link>
            <router-link :to="{name:'policy'}">{{ $t('textpages.policytitle') }}</router-link>
            <router-link :to="{name:'terms'}">{{ $t('textpages.termstitle') }}</router-link>
            <router-link :to="{name:'avg'}">{{ $t('account.avg.title') }}</router-link>
            <router-link :to="{name:'promos'}">{{ $t('textpages.promostitle') }}</router-link>
            <router-link :to="{name:'help'}">{{ $t('textpages.helptitle') }}</router-link>
            <router-link :to="{name:'us2257'}">2257</router-link>
            <a v-if="config.Themename !== 'camcammer'" :href="$t('footer.sexstoriesurl-' + config.Themename)">{{ $t('footer.sexstories') }}</a>
            <a :href="$t('footer.webcamurl-' + config.Themename)">{{ $t('footer.webcam') }}</a>
        </div>
    </div>
</footer>
